/* This is a re-usable vue component for rendering a user avatar that
      does not need to link to the user's profile. The image and an optional
      tooltip can be configured by props passed to this component.

      Sample configuration:

      <user-avatar
        lazy
        :img-src="userAvatarSrc"
        :img-alt="tooltipText"
        :tooltip-text="tooltipText"
        tooltip-placement="top"
        :size="24"
      />

    */ import { GlTooltip, GlAvatar } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { isObject } from 'lodash-es';
import defaultAvatarUrl from 'images/no_avatar.png';
import { __ } from '~/locale';
import { placeholderImage } from '~/lazy_loader';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import { appendWidthToAvatarUrl } from './utils';
export default {
    name: 'UserAvatarImage',
    components: {
        GlTooltip,
        GlAvatar
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        lazy: {
            type: Boolean,
            required: false,
            default: false
        },
        imgSrc: {
            type: String,
            required: false,
            default: defaultAvatarUrl
        },
        cssClasses: {
            type: String,
            required: false,
            default: ''
        },
        imgAlt: {
            type: String,
            required: false,
            default: __('user avatar')
        },
        size: {
            type: [
                Number,
                Object
            ],
            required: true
        },
        tooltipText: {
            type: String,
            required: false,
            default: ''
        },
        tooltipPlacement: {
            type: String,
            required: false,
            default: 'top'
        },
        // Render avatar using pseudo-elements so that they cannot be selected or copied
        pseudo: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        // API response sends null when gravatar is disabled and
        // we provide an empty string when we use it inside user avatar link.
        // In both cases we should render the defaultAvatarUrl
        sanitizedSource () {
            const baseSrc = this.imgSrc === '' || this.imgSrc === null ? defaultAvatarUrl : this.imgSrc;
            return appendWidthToAvatarUrl(baseSrc, this.maximumSize);
        },
        maximumSize () {
            if (isObject(this.size)) {
                return Math.max(...Object.values(this.size)) * 2;
            }
            return this.size * 2;
        },
        resultantSrcAttribute () {
            return this.lazy ? placeholderImage : this.sanitizedSource;
        }
    }
};
